import React from "react";
import AvailabilityCalendar from "../components/AvailabilityCalendar";
import EnquiryForm from "../components/EnquiryForm";
import SEOHead from "../components/SEOHead";
import { CONTACT, MAGIC_PHOTOS } from "../data/cruiseData";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Availability() {
 return (
 <main data-testid="availability-page" className="pt-24">
 <SEOHead
 title="Live Availability · Check Your Date | Magic Cruises Sydney Harbour"
 description="Check live availability for Sydney Harbour cruises. Pick your date, NYE, Vivid, Christmas, birthdays, weddings, and book straight from our hosted calendar."
 image={MAGIC_PHOTOS.fireworksCollage}
 type="WebPage"
 />

 <section className="mx-auto max-w-7xl px-5 lg:px-10 pt-8 pb-6">
 <div className="eyebrow">Plan Your Cruise</div>
 <h1 className="font-display text-5xl lg:text-7xl mt-3 leading-[1.02] text-ink">
 Live availability,<br/><em className="italic text-pink">priced &amp; ready to book.</em>
 </h1>
 <p className="text-ink-soft text-lg max-w-2xl mt-5">
 Pick a date below to see real-time availability and jump straight to our hosted booking system. Popular dates, NYE, Vivid Sydney, Australia Day, fill up fast, so secure yours early.
 </p>
 </section>

 <section className="mx-auto max-w-7xl px-5 lg:px-10 pb-16">
 <div className="grid lg:grid-cols-5 gap-8">
 <div className="lg:col-span-3">
 <AvailabilityCalendar />
 </div>
 <div className="lg:col-span-2 space-y-5">
 <div className="bg-white rounded-2xl border border-[hsla(220,20%,82%,0.6)] p-6">
 <div className="eyebrow">Prefer to chat?</div>
 <h2 className="font-display text-2xl text-ink mt-3">Talk to our cruise team.</h2>
 <p className="text-ink-soft text-sm mt-2">We answer same-day with a custom quote.</p>
 <div className="mt-5 space-y-3 text-sm font-medium">
 <a href={`tel:${CONTACT.phone1}`} className="flex items-center gap-3 text-ink hover:text-pink"><Phone className="w-4 h-4 text-pink" /> {CONTACT.phone1}</a>
 <a href={`tel:${CONTACT.phone2}`} className="flex items-center gap-3 text-ink hover:text-pink"><Phone className="w-4 h-4 text-pink" /> {CONTACT.phone2}</a>
 <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-ink hover:text-pink"><Mail className="w-4 h-4 text-pink" /> {CONTACT.email}</a>
 <div className="flex items-center gap-3 text-ink-soft"><MapPin className="w-4 h-4 text-pink" /> {CONTACT.embarkation}</div>
 </div>
 </div>
 <EnquiryForm sourcePage="availability" />
 </div>
 </div>
 </section>
 </main>
 );
}
